import styled from 'styled-components';

export const EmailReceiptWrapper = styled.div`
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
`;
